import type { HydratedDocument } from 'mongoose';

export function isMongooseDocument<DocType = unknown>(obj: any): obj is HydratedDocument<DocType> {
  return (
    obj &&
    (obj.schema !== undefined ||
      obj.$__ !== undefined ||
      typeof obj.isModified === 'function' ||
      typeof obj.save === 'function' ||
      typeof obj.parent === 'function' ||
      typeof obj.toObject === 'function' ||
      typeof obj.toJSON === 'function')
  );
}
